<template>
  <div class="distributor-box back-fff p20">
    <!--返回按钮-->
    <div class="go-back" @click="goBackBtn">
      <Icon class="back-icon" type="ios-arrow-back"/>
      <span class="back-txt">{{ $t('key1002627') }}</span>
    </div>
    <div class="modifyPassword_box">
      <Form ref="modifyPasswordForm" :model="modifyPasswordForm" :rules="modifyPasswordRuleValidate"
        class="mobileForm" :label-width="120" @submit.native.prevent>
        <Row>
          <Col :xxl="oneItemCol" class="center_style">
            <Form-item :label="$t('key1005526')" prop="oldPassword">
              <Input clearable type="password"
                v-model.trim="modifyPasswordForm.oldPassword"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" class="center_style">
            <Form-item :label="$t('key1005527')" prop="newPassword">
              <Input clearable type="password"
                v-model.trim="modifyPasswordForm.newPassword"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" class="center_style">
            <Form-item :label="$t('key1005528')" prop="password">
              <Input clearable type="password"
                v-model.trim="modifyPasswordForm.password"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" class="center_style">
            <div class="update_btn" @click="updateBtn">{{ $t('key1000337') }}</div>
          </Col>
        </Row>
      </Form>
    </div>
  </div>
</template>

<style lang="less" scoped>
.modifyPassword_box {
  width: 560px;
  margin: 30px auto 0;
  height: 464px;

  .mobileForm {
    margin-top: 60px;

    /deep/ .ivu-input-wrapper-default {
      width: 300px;
    }

    .center_style {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    /deep/ .ivu-input {
      height: 35px;
      line-height: 35px;
    }

    .update_btn {
      margin: 40px auto 20px;
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #FD5425;
      border-radius: 2px;
      box-sizing: border-box;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }
  }

}
</style>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';

export default {
  name: "modifyPassword",
  data() {
    let v = this;
    return {
      oneItemCol: { // 划分为一等分
        span: 24
      },
      current: 0,
      modifyPasswordForm: {
        oldPassword: '',
        newPassword: '',
        password: ''
      },
      modifyPasswordRuleValidate: {
        oldPassword: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005522'),
            trigger: 'blur'
          }
        ],
        newPassword: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005523'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            validator: v.validatenewPassword(),
            required: true,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    // 返回列表
    goBackBtn() {
      this.$router.push('/securityInformation');
    },
    // 更新
    updateBtn() {
      let v = this;
      v.$refs.modifyPasswordForm.validate((valid) => {
        if (valid) {
          let query = {
            oldPassword: v.modifyPasswordForm.oldPassword,
            newPassword: v.modifyPasswordForm.newPassword
          };
          v.axios.put(api.put_ymsDistributorMerchant_updatePassword, query).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005524'));
              v.$refs['modifyPasswordForm'].resetFields();
            }
          });
        }
      });
    },
    // 校验新密码与旧密码
    validatenewPassword() {
      let v = this;
      return function (rule, value, callback) {
        if (!value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000997')));
        } else if (v.modifyPasswordForm.newPassword !== value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005525')));
        } else {
          callback();
        }
      };
    }
  }
};
</script>

<style scoped>

</style>
